import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { resetPassword } from 'actions'
import {
  resetPasswordSuccessSelector,
  resetPasswordErrorSelector,
} from 'selectors'
import { body } from 'styles/texts'

import { Form, Field, Input, FormContainer } from 'components/form'
import ButtonComponent from 'components/Button'

const FormWrapper = styled(FormContainer)`
  margin: auto;
`

const Button = styled(ButtonComponent)`
  margin-top: 10px;
  width: 186px;
  align-self: center;
`

const Text = styled.div`
  ${body};
  font-size: 17px;
  margin: 20px 0;
`

const Success = styled.div`
  ${body};
  font-size: 17px;
  padding: 20px 20px 30px;

  @media (min-width: 640px) {
    padding: 30px 60px 60px;
  }
`

class ResetPassword extends React.Component {
  state = {
    email: '',
  }

  componentDidMount() {
    document.body.style.backgroundColor = '#5F4B76'
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = ''
  }

  resetPassword = e => {
    e.preventDefault()
    this.props.resetPassword(this.state.email)
  }

  render() {
    return (
      <FormWrapper small title="Tilbakestill passord">
        {this.props.success ? (
          <Success>
            Hjelpen er på vei!{' '}
            <span role="img" aria-label="ambulance">
              🚑
            </span>
          </Success>
        ) : (
          <Form onSubmit={this.resetPassword}>
            <Text>
              Skriv inn e-postadressen din, så sender vi deg en lenke for å
              tilbakestille passordet.
            </Text>
            <Field>
              <Input
                placeholder="E-post"
                id="email"
                type="email"
                value={this.state.email}
                onChange={e => this.setState({ email: e.target.value })}
                error={this.props.emailError}
                required
              />
            </Field>
            <Button size="large" type="submit">
              Send
            </Button>
          </Form>
        )}
      </FormWrapper>
    )
  }
}

const mapStateToProps = state => ({
  emailError: resetPasswordErrorSelector(state),
  success: resetPasswordSuccessSelector(state),
})

const mapDispatchToProps = { resetPassword }

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)



// WEBPACK FOOTER //
// ./src/pages/ResetPassword.js